import { useActiveOrganization } from "@/contexts"
import {
  isEnergyAndWaterUseWorkbookId,
  useSigmaWorkbooks,
} from "@/services/sigma"
import type { SigmaWorkbook } from "@/services/sigma"

import { reportCards } from "../../models/report"
import { getCustomWorkbooksWorkspaceName } from "../../util/get-custom-workbooks-workspace-name"

const isStaticReportCard = (
  workbookId: SigmaWorkbook["workbookId"] | undefined
) =>
  isEnergyAndWaterUseWorkbookId(workbookId) ||
  reportCards.some((card) => Boolean(card.id) && card.id === workbookId)

export interface UseHasWorkbookAccessValue {
  hasWorkbookAccess: boolean
  isStaticReportCard: boolean
  isWorkbookAccessLoading: boolean
}

export const useHasWorkbookAccess = (
  workbookId: SigmaWorkbook["workbookId"] | undefined
): UseHasWorkbookAccessValue => {
  const { activeOrganization } = useActiveOrganization()
  const staticReportCard = isStaticReportCard(workbookId)
  const customWorkspaceName = getCustomWorkbooksWorkspaceName(
    activeOrganization?.id,
    activeOrganization?.name
  )

  const {
    sigmaWorkbooksData,
    sigmaWorkbooksIsFetched,
    sigmaWorkbooksIsPlaceholderData,
  } = useSigmaWorkbooks({
    apiOptions: {
      placeholderCount: 0,
      workspaceNames: staticReportCard ? [] : [customWorkspaceName],
    },
  })

  const isWorkbookAccessLoading =
    !staticReportCard &&
    (!sigmaWorkbooksIsFetched || sigmaWorkbooksIsPlaceholderData)

  const hasWorkbookAccess =
    staticReportCard ||
    Boolean(
      sigmaWorkbooksData?.entries.some(
        (workbook) => workbook.workbookId === workbookId
      )
    )

  return {
    hasWorkbookAccess,
    isStaticReportCard: staticReportCard,
    isWorkbookAccessLoading,
  }
}
